import React from "react";
import {List} from "../modules/Contacts/index";

export function ContactsListPage() {
  return (
    <List />
  );
}
